interface DateCondition {
  type: string;
  dateFrom: string;
  dateTo: string;
}

interface DateFilterCondition {
  operator?: string;
  type?: string;
  dateFrom?: string;
  dateTo?: string;
  conditions?: DateCondition[];
  condition1?: DateCondition;
  condition2?: DateCondition;
}

export const getDateFilter = (
  dateField: string,
  condition: DateFilterCondition,
) => {
  if (condition.operator) {
    let dateRanges: any[] = [];
    if (condition.conditions) {
      dateRanges = condition.conditions.map((dateCondition: DateCondition) => {
        if (dateCondition.type === 'inRange') {
          return {
            and: [
              {
                [dateField]: {
                  gte: new Date(dateCondition.dateFrom).toISOString(),
                },
              },
              {
                [dateField]: {
                  lte: new Date(dateCondition.dateTo).toISOString(),
                },
              },
            ],
          };
        }
        return {
          [dateField]: {
            gt: new Date(dateCondition.dateFrom).toISOString(),
          },
        };
      });
    } else if (condition.condition1) {
      dateRanges = [
        condition.condition1.type === 'inRange'
          ? {
              and: [
                {
                  [dateField]: {
                    gte: new Date(condition.condition1.dateFrom).toISOString(),
                  },
                },
                {
                  [dateField]: {
                    lte: new Date(condition.condition1.dateTo).toISOString(),
                  },
                },
              ],
            }
          : {
              [dateField]: {
                gt: new Date(condition.condition1.dateFrom).toISOString(),
              },
            },
      ];

      if (condition.condition2) {
        dateRanges.push(
          condition.condition2.type === 'inRange'
            ? {
                and: [
                  {
                    [dateField]: {
                      gte: new Date(
                        condition.condition2.dateFrom,
                      ).toISOString(),
                    },
                  },
                  {
                    [dateField]: {
                      lte: new Date(condition.condition2.dateTo).toISOString(),
                    },
                  },
                ],
              }
            : {
                [dateField]: {
                  gt: new Date(condition.condition2.dateFrom).toISOString(),
                },
              },
        );
      }
    }

    return {
      [condition.operator.toLowerCase()]: dateRanges,
    };
  }

  if (condition.type === 'inRange') {
    return {
      and: [
        { [dateField]: { gte: new Date(condition.dateFrom!).toISOString() } },
        { [dateField]: { lte: new Date(condition.dateTo!).toISOString() } },
      ],
    };
  }

  if (condition.type === 'equals') {
    const dateFrom = new Date(condition.dateFrom!);
    const dateTo = new Date(dateFrom);
    dateTo.setDate(dateTo.getDate() + 1);

    return {
      and: [
        { [dateField]: { gte: dateFrom.toISOString() } },
        { [dateField]: { lt: dateTo.toISOString() } },
      ],
    };
  }

  const filters: any[] = [];
  if (condition.dateFrom) {
    filters.push({
      [dateField]: { gt: new Date(condition.dateFrom).toISOString() },
    });
  }
  if (condition.dateTo) {
    filters.push({
      [dateField]: { lt: new Date(condition.dateTo).toISOString() },
    });
  }

  return {
    and: filters,
  };
};
